import { useRef, useState } from "react";
import { getParsedSessionCookie } from "../cookie";
import { useClickOutside } from "../hooks/useClickOutside";
import DownChevron from "../images/svg/DownChevron";

export default function LoginNavbar({ noAuth }: { noAuth?: boolean }) {
  const [toggle, setToggle] = useState(false);
  const logoutWrapperRef = useRef<HTMLInputElement>(null);

  useClickOutside(logoutWrapperRef, () => setToggle(false));

  const username = !noAuth ? getParsedSessionCookie()?.userName : null;

  return (
    <header className="sticky top-0 w-full h-[73.45px] z-40">
      <div className="h-full w-full light:bg-white dark:bg-[#3a3a3a] shadow-sm">
        <div className="flex flex-row items-center justify-between w-full max-w-[1600px] h-full px-8 mx-auto">
          <div className="flex items-center">
            <a href="/">
              <span className="text-black dark:text-white font-bold text-base md:text-lg">
                S-Process
              </span>
            </a>
          </div>
          {!noAuth && (
            <div
              className="relative inline-block text-left"
              ref={logoutWrapperRef}
            >
              <div>
                <button
                  className="inline-flex w-full justify-center px-4 py-2 text-lg font-medium"
                  onClick={() => setToggle((prev) => !prev)}
                >
                  {username || "Signed in"}
                  <DownChevron
                    className="light:fill-black dark:fill-white"
                    style={{
                      marginLeft: "0.5rem",
                      marginTop: "auto",
                      marginBottom: "auto",
                      height: "1.5rem",
                      width: "1.5rem",
                    }}
                  />
                </button>
              </div>
              {toggle ? (
                <div className="absolute right-0 z-10 mt-2 px-4 rounded-md light:bg-white dark:bg-stone-800 shadow-md border border-black/5 outline-none">
                  <a
                    href="/api/logout"
                    className="block w-full px-4 py-3 text-left text-lg min-w-[100px]"
                  >
                    Sign out
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
